import { Tag, Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import RoundShape from '../../Atoms/RoundShape/RoundShape';
import './SimpleCardView.less';

/**
 * @component SimpleCardView.tsx
 * @description SimpleCardView component for the task
 * @return { Component }
 */
interface SimpleCardViewProps {
  task: any;
  onClick: (item: object) => void;
  isRol: boolean;
}
function SimpleCardView(props: SimpleCardViewProps) {
  const { Text } = Typography;
  const onChange = (item: object) => {
    props.onClick(item);
  };
  return (
    <div className="org-card-view__simple__content">
      <div className="org-card-view__simple__header">
        {!props.isRol && (
          <RoundShape
            color={'#' + props.task.color}
            width={'16px'}
            height={'16px'}
            colorOnClick={() => {}}
            isEdit={false}
          />
        )}
        <Text ellipsis={true} className={`org-card-view__simple__title${props.isRol ? "-rol" : ""}`}>
          {props.isRol ? props.task.rol : props.task.tipotarea}
        </Text>
          <EditOutlined
            className="org-card-view__simple__icon"
            onClick={() => onChange(props)}
          />
      </div>
      <Tag
        className="org-card-view__simple__tag"
        color={props.task.activo ? 'green' : 'default'}
      >
        {props.task.activo ? 'Activo' : 'Inactivo'}
      </Tag>
    </div>
  );
}

export default SimpleCardView;
